import type { IconNode } from '../types';

/**
 * @name philippine-peso
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCAxMmgxNiIgLz4KICA8cGF0aCBkPSJNNCA4aDE2IiAvPgogIDxwYXRoIGQ9Ik02IDIwVjVhMSAxIDAgMDExLTFoNWE2IDYgMCAwMTAgMTJINiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/philippine-peso
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const PhilippinePeso: IconNode = [
  ['path', { d: 'M4 12h16' }],
  ['path', { d: 'M4 8h16' }],
  ['path', { d: 'M6 20V5a1 1 0 011-1h5a6 6 0 010 12H6' }],
];

export default PhilippinePeso;
